<div class="fs-2 with-close" mat-dialog-title>
    Vous devez vraiment nous aimer !
    <i class="fa fa-close" (click)="onNoClick()" *ngIf="disableClose == false" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Vous avez découvert une fonctionnalité premium !</b>
    <p class="mb-0 text-center">
        <img class="img-fluid mt-3 mb-3" src="{{ visuel }}"><br/>
        <b>{{ feature }}</b><br/>
        (Disponible à partir du forfait "{{plan}}")
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" *ngIf="disableClose == false" class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-info {{ disableClose == true ? 'center' : '' }}">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Débloquer cette fonctionnalité</ng-container>
    </button>
</div>
